
import ChangeColorDark from './ChangeColorDark.jsx'
import ChangeColorLight from './ChangeColorLight.jsx'
import IP from './IP.jsx'
import Logout from './Logout.jsx'
import PSTranscriptsLogo from './PSTranscriptsLogo.jsx'
import SendToEmail from './SendToEmailIcon.jsx'

import clear from './svg-in-string/clear'
import columnsMenu from './svg-in-string/columnsMenu'
import delet from './svg-in-string/delete'
import download from './svg-in-string/download'
import downloadFileMessage from './svg-in-string/downloadFileMessage'
import error from './svg-in-string/error'
import exportAllToTxt from './svg-in-string/exportAllToTxt'
import exportAllToXls from './svg-in-string/exportAllToXls'
import exportSelectedToTxt from './svg-in-string/exportSelectedToTxt'
import exportSelectedToXls from './svg-in-string/exportSelectedToXls'
import reload from './svg-in-string/reload'
import warning from './svg-in-string/warning'

import svgIcon from './SvgIcon'

export const ChangeColorDarkIcon = ChangeColorDark;
export const ChangeColorLightIcon = ChangeColorLight;
export const IPIcon = IP;
export const LogoutIcon = Logout;
export const PSTranscriptsLogoIcon = PSTranscriptsLogo;

export const SendToEmailIcon = SendToEmail;

/* svg-in-string */
export const clearIcon = clear
export const columnsMenuIcon = columnsMenu
export const deleteIcon = delet
export const downloadIcon = download
export const downloadFileMessageIcon = downloadFileMessage
export const errorIcon = error
export const exportAllToTxtIcon = exportAllToTxt
export const exportAllToXlsIcon = exportAllToXls
export const exportSelectedToTxtIcon = exportSelectedToTxt
export const exportSelectedToXlsIcon = exportSelectedToXls
export const reloadIcon = reload
export const warningIcon = warning

export const SvgIcon = svgIcon
